// Settings page (/settings/mentor): profile photo and password messages that
// follow the backend's real rules. The older page strings stay in `settings`.
const settingsAccount = {
  en: {
    nameTooShort: 'Name must be at least 2 characters',
    photoType: 'Choose a JPG, PNG, GIF or WebP image',
    photoTooBig: 'Choose an image up to 5 MB',
    photoFailed: 'Could not upload the photo',
    newPasswordPlaceholder: 'Min 8 characters',
    pwRules: 'Use 8–128 characters with an uppercase letter, a lowercase letter and a number',
    pwChanged: 'Password updated',
    pwWrongCurrent: 'Current password is incorrect',
    pwFailed: 'Could not update the password',
  },
  ru: {
    nameTooShort: 'Имя должно содержать не менее 2 символов',
    photoType: 'Выберите изображение JPG, PNG, GIF или WebP',
    photoTooBig: 'Выберите изображение размером до 5 МБ',
    photoFailed: 'Не удалось загрузить фото',
    newPasswordPlaceholder: 'Не менее 8 символов',
    pwRules: 'Используйте от 8 до 128 символов: заглавная буква, строчная буква и цифра',
    pwChanged: 'Пароль обновлён',
    pwWrongCurrent: 'Текущий пароль указан неверно',
    pwFailed: 'Не удалось обновить пароль',
  },
  uz: {
    nameTooShort: "Ism kamida 2 ta belgidan iborat bo'lishi kerak",
    photoType: "JPG, PNG, GIF yoki WebP rasmini tanlang",
    photoTooBig: "5 MB gacha bo'lgan rasmni tanlang",
    photoFailed: "Rasmni yuklab bo'lmadi",
    newPasswordPlaceholder: 'Kamida 8 ta belgi',
    pwRules: "8–128 ta belgi ishlating: bosh harf, kichik harf va raqam bo'lsin",
    pwChanged: 'Parol yangilandi',
    pwWrongCurrent: "Joriy parol noto'g'ri",
    pwFailed: "Parolni yangilab bo'lmadi",
  },
};

export default settingsAccount;
